import r, { useContext as t } from "react";
import { PrimaryNavContext as e } from "./PrimaryNavContext";
import { DesktopUserActionsTrigger as i } from "./DesktopUserActionsTrigger";
import { SkeletonLoader as m } from "./SkeletonLoader";

var u = function u() {
  var _t = t(e),
      o = _t.isAuthLoading;

  return o ? r.createElement(m, null) : r.createElement(i, null);
};

export { u as AuthChecker };